import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';

import SettingsContent from '../Wrapper.vue';
import SettingsWrapper from '../SettingsWrapper.vue';

import WgptMcpServers from './Index.vue';
import Editor from './edit/Index.vue';
import ToolEditor from './edit/tools/edit/ToolEditor.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/wgpt-mcp-servers'),
      meta: {
        featureFlag: FEATURE_FLAGS.WGPT_MCP_SERVERS,
        permissions: ['administrator'],
      },
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'wgpt_mcp_servers_list',
          component: WgptMcpServers,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/wgpt-mcp-servers'),
      meta: {
        featureFlag: FEATURE_FLAGS.WGPT_MCP_SERVERS,
        permissions: ['administrator'],
      },
      component: SettingsContent,
      props: () => {
        return {
          headerTitle: 'WGPT_MCP_SERVERS.HEADER',
          icon: 'plug',
          showBackButton: true,
        };
      },
      children: [
        {
          path: ':serverId/edit/:tab?',
          name: 'wgpt_mcp_servers_edit',
          component: Editor,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
    {
      path: frontendURL(
        'accounts/:accountId/settings/wgpt-mcp-servers/:serverId/tools/:toolId'
      ),
      name: 'wgpt_mcp_servers_edit_tool',
      meta: {
        featureFlag: FEATURE_FLAGS.WGPT_MCP_SERVERS,
        permissions: ['administrator'],
      },
      component: ToolEditor,
    },
  ],
};
